import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";

import CancelButtonStyled from "components/button/CancelButtonStyled";
import SaveButton from "components/button/SaveButton";

import {sessionStore} from "utils/sessionStore";
import {getSessionOrganizations} from "actions/authentication";
import {clearRequestedLocation, getCurrentSubdomain, getRequestedLocation} from "utils/requestedLocation";
import {changeCurrentOrganization} from "api/user/update";

function RequestedLocationHandler() {
    const history = useHistory();
    const [pendingSwitch, setPendingSwitch] = useState(null);

    useEffect(() => {
        const requested = getRequestedLocation();

        if (!requested) {
            return;
        }

        const member = sessionStore.get("member");
        const organizations = getSessionOrganizations();

        if (!member || !organizations) {
            return;
        }

        const currentOrganization = organizations[member.organization];

        if (currentOrganization?.subdomain !== getCurrentSubdomain()) {
            return;
        }

        clearRequestedLocation();

        if (currentOrganization.subdomain === requested.subdomain) {
            history.push(requested.path);
            return;
        }

        const targetOrganization = Object.values(organizations).find(
            (organization) => organization.subdomain === requested.subdomain
        );

        if (targetOrganization) {
            setPendingSwitch({
                organization: targetOrganization,
                path: requested.path,
                userId: member.userId,
            });
        }
    }, [history]);

    if (!pendingSwitch) {
        return null;
    }

    const closeDialog = () => setPendingSwitch(null);

    const confirmSwitch = () => {
        changeCurrentOrganization(pendingSwitch.userId, pendingSwitch.organization.id, pendingSwitch.path);
    };

    return (
        <Dialog open onClose={closeDialog} maxWidth={"xs"} scroll={"body"}>
            <DialogTitle>
                <FormattedMessage id={"requestedLocation.crossOrganization.title"} />
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <FormattedMessage
                        id={"requestedLocation.crossOrganization.description"}
                        values={{organization: <strong>{pendingSwitch.organization.name}</strong>}}
                    />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CancelButtonStyled onClick={closeDialog}>
                    <FormattedMessage id={"list.button.cancel"} />
                </CancelButtonStyled>
                <SaveButton onClick={confirmSwitch}>
                    <FormattedMessage id={"requestedLocation.crossOrganization.confirm"} />
                </SaveButton>
            </DialogActions>
        </Dialog>
    );
}

export default RequestedLocationHandler;
